export default {
  computed: {
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    cardAlias () {
      if (this.isCustomCard) {
        return this.card.customCard.name
      }

      return this.card && this.card.alias ? this.card.alias : ''
    },
    cardType () {
      return this.card && this.card.type ? this.card.type.code : ''
    },
    cardUserProfilePicture () {
      return this.cardUser && this.cardUser.profilePicture
        ? this.cardUser.profilePicture.id
        : 0
    },
    customCardLogo () {
      if (this.isCustomCard) {
        return this.card.customCard.logo.id
      }
      return 0
    },
    isCustomCard () {
      return !!(this.card && this.card.customCard && this.card.customCard.id)
    },
    cardAssignedBudgetName () {
      return this.card && this.card.assignedBudget
        ? this.card.assignedBudget.name
        : ''
    },
    cardUserOwnerFullName () {
      return this.card && this.card.user
        ? `${this.card.user.firstName} ${this.card.user.lastName}`
        : ''
    },
    cardUser () {
      return this.card && this.card.user ? this.card.user : false
    },
    cardStatus () {
      return this.card && this.card.status ? this.card.status.code : ''
    },
    cardPartialPan () {
      return this.card && this.card.partialPAN ? this.card.partialPAN : ''
    },
    cardMPNumber () {
      return this.card && this.card.externalId ? this.card.externalId : ''
    },
    disabledCardStatuses () {
      return ['PENDING', 'DISABLED', 'CANCELLED']
    },
    isCardPhysical () {
      return this.cardType === 'MEMBER_PHYSICAL'
    },
    isCardDisabled () {
      return this.disabledCardStatuses.includes(this.cardStatus)
    },
    isCardFreezable () {
      return this.cardStatus === 'ACTIVE'
    },
    isCardUnfreezable () {
      return this.cardStatus === 'FROZEN'
    },
    isCardUnfreezableByAdmin () {
      return this.cardStatus === 'FROZEN_BY_ADMIN'
    },
    cardItemStatusClass () {
      if (this.isCardFreezable) {
        return 'Cards-itmStatus--freeze'
      } else if (this.isCardUnfreezable || (this.isCardUnfreezableByAdmin && (this.isAdmin || this.isSuperAdmin))) {
        return 'Cards-itmStatus--unfreeze'
      } else if (this.isCardUnfreezableByAdmin) {
        return 'Cards-itmStatus--freeze-by-admin'
      }
      return ''
    },
    cardStatusActionLabelRender () {
      if (this.cardStatus === 'FROZEN' || (this.cardStatus === 'FROZEN_BY_ADMIN' && (this.isAdmin || this.isSuperAdmin))) {
        return 'card_status_action_unfreeze_card'
      } else if (this.cardStatus === 'ACTIVE') {
        return 'card_status_action_freeze_card'
      } else if (this.cardStatus === 'FROZEN_BY_ADMIN') {
        return 'card_status_action_freeze_by_admin_card'
      }
      return this.cardStatus.code
    },
    cardSpent () {
      return this.card &&
        this.card.assignedBudget &&
        this.card.assignedBudget.userBudget
        ? this.card.assignedBudget.userBudget.spent
        : ''
    },
    cardAssigned () {
      return this.card &&
        this.card.assignedBudget &&
        this.card.assignedBudget.userBudget
        ? this.card.assignedBudget.userBudget.assigned
        : ''
    }
  }
}
